import React, {useState} from 'react'
import { Button } from '../button/Button'
import './Activation.scss'
import {faTimes} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const BACKGROUND = ["dota--bg" , "molen--bg", "ff--bg", "valor--bg"]

const Activation = ({bgCover,onClose,imageLogo}) => {

    const [change,setChange] = useState({id:'', accountName:''})

    const checkBackgroundImage = BACKGROUND.includes(bgCover) ? bgCover : null

    return (
        <>
        <div className="activation">
            <div className={`activation__container ${checkBackgroundImage}`}>
                <div className="activation__closetag">
                    <div className="activation__closetag-wrap" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} size='lg' className="close"/>
                    </div>  
                </div>

                <div className="activation__container-wrap">
                    <div className="activation__header">
                        <div className="act-header-wrap">
                            <h1>Activation</h1>
                        </div>
                        <div className="act-image-wrap">
                            <img src={imageLogo} alt="imagelogo"/>
                        </div>
                    </div>

                    <div className="activation__id">
                        <p>Id :</p>
                        <input 
                            type="text"
                            value={change.id}
                            onChange={(e) => setChange({...change,id:e.target.value})}
                        />
                    </div>

                    <div className="activation__acc-name">
                        <p>Account Name : </p>
                        <input 
                            type="text"
                            value={change.accountName}
                            onChange={(e) => setChange({...change,accountName:e.target.value})}
                        />
                    </div>

                    <div className="activation__button">
                        <Button buttonColor="orange" buttonSize="btn--wide">Active</Button>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default Activation
